import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import institusionAbi from "../../utils/institusion.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseDop1 = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.dop;

  const purchaseDop1 = useCallback(
    async (amount, postApiRes, id, balance, min) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      console.log(amount, id, balance, min, "min");

      amount = parseFloat(amount).toFixed(6);
      const amount1 = Math.round(amount * 1e12) / 1e12;
      const nd = parseEther(amount1.toString());

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      console.log(min, minvalue, UsdtAdress, nd, postApiRes.code, postApiRes?.normalizationFactor, postApiRes.referenceTokenPrice, id, postApiRes.price, postApiRes.deadline);

      try {
        const hash = await writeContractAsync({
          address: Environment.instituson,
          abi: institusionAbi,
          functionName: "purchaseWithToken",
          args: [
            UsdtAdress,
            nd,
            postApiRes.code,
            postApiRes?.normalizationFactor,
            postApiRes.referenceTokenPrice,
            minvalue,
            id,
            postApiRes.price,
            postApiRes.deadline,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("PurchaseDop1 tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("PurchaseDop1 confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("PurchaseDop1 error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseDop1 };
};

export default usePurchaseDop1;
